import InputTypesEnum from '../../../Enums/InputTypesEnum';
import ValidityHelper from '../../../Helpers/ValidityHelper';
import ClientService from '../../../Services/clientService';

// Trivial placeholder: the wizard only instantiates windowDescription.itemType when no
// editedItem prop is passed. ClientAdmin always passes the selected client (crudType=Update),
// so this is never invoked, but it keeps the windowDescription contract satisfied.
class ClientSassieEditItem {}

export default class ClientSassieWindowDescription {
  static titleForEdit = (item) => `Insert Apollo Client ID for ${item.Name}`;
  static itemType = ClientSassieEditItem;
  static finishButtonLabel = 'Save';
  static messageOnSuccess = 'Apollo Client ID has been linked.';

  // Mirrors the old ClientSassieAdminPanel's Validate-then-Save flow in a single pass: look up
  // the Apollo client by SassieId, surface any lookup message/disabled state as an error, require
  // the "Link anyway" toggle to confirm a client-name mismatch, then persist the link. MUST return
  // the promise (wizard contract).
  static serviceFunction = (edited) =>
    ClientService.GetClientByProjectSassieIdId(edited.SassieId).then((result) => {
      const client = result && result.client;
      if (!client) return { error: 'Error! ErrorCode: CSAP112' };
      if (client.message) return { error: client.message };
      if (client.disabled) return { error: 'This Apollo client is disabled and cannot be linked.' };
      if (edited.Name !== client.client_name && !edited.ConfirmMismatch) {
        return {
          error: `Validation is Falied! Apollo Client id: ${client.client_id} is mapped to Client name: ${client.client_name}. Turn on "Link anyway" to confirm linking it to "${edited.Name}".`,
        };
      }
      return ClientService.UpdateSassieId(edited.ClientId, edited.SassieId, client.client_name).then((res) =>
        res === '' ? {} : { error: res }
      );
    });

  static pagesInGeneralEditWizzard = [
    {
      label: 'Apollo Client ID',
      fields: [
        {
          fieldName: 'SassieId',
          label: 'Apollo Client ID',
          className: 'col-6',
          type: InputTypesEnum.Number,
          validityChecker: ValidityHelper.forRequiredNumberFieldGreaterThanZero,
          onFieldChange: (item) => {
            item.ConfirmMismatch = false;
          },
        },
        {
          fieldName: 'ConfirmMismatch',
          label: 'Link anyway (Apollo client name differs)',
          className: 'col-6',
          type: InputTypesEnum.OnOff,
          validityChecker: ValidityHelper.AlwaysFlawless,
        },
      ],
    },
  ];
}
